export default __webpack_public_path__ + "static/Tablet-44f48bb4737b86abad65731285df4fad.jpg";